import { useState, type FormEvent } from 'react';
import { ProvaliaLogoStacked } from '../../shared/brand';
import { ErrorBox } from '../../shared/ui';
import { api, setSessionName } from '../api';
import { FormField } from '../components/FormField';

interface LoginResponse {
  token: string;
  session: { name: string; sub: string };
}

export function Login({ onLoggedIn }: { onLoggedIn: (name: string) => void }): JSX.Element {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api.post<LoginResponse>('/admin/login', { username: username.trim(), password });
      api.setToken(res.token);
      const name = res.session.name || res.session.sub;
      setSessionName(name);
      onLoggedIn(name);
    } catch (err) {
      setError(err);
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="card login-card">
        <div className="card-body">
          <div className="login-brand">
            <ProvaliaLogoStacked height={104} />
            <span className="pv-logo-sub">Administración</span>
            <p className="muted">Panel de ECINSA para dar de alta y configurar los portales de proveedores de cada cliente.</p>
          </div>
          <form className="stack" onSubmit={submit} noValidate>
            <FormField label="Usuario">
              <input
                className="input"
                autoComplete="username"
                autoCapitalize="none"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
                required
              />
            </FormField>
            <FormField label="Contraseña">
              <input
                className="input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormField>
            <ErrorBox error={error} />
            <button className="btn primary block" type="submit" disabled={busy || !username.trim() || !password}>
              {busy ? 'Entrando…' : 'Entrar'}
            </button>
          </form>
          <p className="subtle login-help">
            Los administradores se crean en el servidor con <code>npm run admin -- &lt;usuario&gt;</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
